export const FOOTBALL = 2
export const BASEBALL = 3
export const AM_FOOTBALL = 4
export const BASKETBALL = 5
export const HOCKEY = 6
export const TENNIS = 8
export const FIGHTING = 9
export const GOLF = 10
export const CRICKET = 11
export const HORSE_RACING = 23
export const RUGBY = 13
